import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import { CustomerDetailDao, CustomerOrderDao, CustomerSearchRowDao } from '@/interfaces/customer/Customer.dao'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'

export default class CustomersService extends ApiService {
    async searchCustomers(params?: IRequestParameters): Promise<[CustomerSearchRowDao[], PageNumberPagination] | null> {
        return this.request<undefined, [CustomerSearchRowDao[], PageNumberPagination] | null>(
            'GET',
            '/customers/search',
            params,
            undefined,
            undefined,
            'searchCustomers',
        ).catch(() => null)
    }

    async getCustomer(id: number): Promise<CustomerDetailDao | null> {
        return this.request<undefined, CustomerDetailDao>(
            'GET',
            `/customers/${id}`,
            undefined,
            undefined,
            undefined,
            'getCustomer',
        ).catch(() => null)
    }

    async getCustomerOrders(params: IRequestParameters): Promise<[CustomerOrderDao[], PageNumberPagination] | null> {
        const { customerId, ...query } = params
        return this.request<undefined, [CustomerOrderDao[], PageNumberPagination] | null>(
            'GET',
            `/customers/${customerId}/orders`,
            query,
            undefined,
            undefined,
            'getCustomerOrders',
        ).catch(() => null)
    }
}
